module.exports = __webpack_public_path__ + "img/upload-data-by-payungkead.7ffa0e47.png";